import React, { memo } from 'react';
import DialogComponent from '../Dialog/DialogComponent';
import { Trans, useTranslation } from 'react-i18next';

const ConfirmMessage = memo(
  ({
    t,
    i18nKey,
    tParams,
    open,
    className = '',
    handleClose,
    message = '',
    title = '',
    onConfirm,
    confirmText = '',
    cancelText = '',
    confirmBtnDisabled = false,
  }) => {
    const { t: tError } = useTranslation(['error', 'common']);
    const finalMessage = !!t ? (
      <Trans t={t} i18nKey={i18nKey}>
        {tParams}
      </Trans>
    ) : (
      message
    );

    return (
      <DialogComponent open={open} className={`${className} react-dialog-confirm`} handleClose={handleClose}>
        {title && title.length ? <h2>{title}</h2> : ''}
        <div>{finalMessage}</div>
        <div className="modal-button-footer">
          <button
            className="btn btn-primary btn-confirm"
            onClick={() => {
              onConfirm();
              handleClose();
            }}
            disabled={confirmBtnDisabled}>
            {confirmText && confirmText.length ? confirmText : tError('common:BUTTON_CONFIRM')}
          </button>
          <button className="btn btn-default btn-cancel" onClick={handleClose} autoFocus>
            {cancelText && cancelText.length ? cancelText : tError('common:BUTTON_CANCEL')}
          </button>
        </div>
      </DialogComponent>
    );
  }
);

export default ConfirmMessage;